module.exports = __webpack_public_path__ + "img/login-left.33c41153.png";